/** @module csi/widget/TextWithMaterialIcon */
define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"dojo/dom-style",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"dijit/_WidgetsInTemplateMixin",
	"csi/html",
	"dojo/text!./TextWithMaterialIcon.html",

	"./MaterialIcon"
], function(declare, domClass, domStyle, _TemplatedMixin, _WidgetBase, _WidgetsInTemplateMixin, html, template) {

	return declare([_WidgetBase, _TemplatedMixin, _WidgetsInTemplateMixin], {
		baseClass: "csi-text-with-material-icon",
		templateString: template,

		// attach points
		iconNode: null,
		textNode: null,

		/** @property {string} icon - name of material icon */
		icon: "",

		/** @property {string} iconColor - color of material icon */
		//iconColor: "none",

		/** @property {boolean} iconLeft - position icon on the left */
		//iconLeft: false,

		/** @property {boolean} iconOnly - hide text, display icon only */
		//iconOnly: false,

		/** @property {string} iconTitle - icon title string */
		iconTitle: "",


		/** @property {boolean} removeIconPointerCursor - remove pointer cursor on icon */
		//removeIconPointerCursor: false,

		/** @property {string|string[]} text - single or multiple text strings to display */
		text: "",

		/**
		 * Extension point for when widget is clicked
		 */
		onClick: function() { },

		/**
		 * Apply icon to appropriate node
		 * @param {string} value 
		 */
		_setIconAttr: function(value) {
			const {iconNode} = this;
			html.setVisible(iconNode, !!value);
			iconNode.set("icon", value);
			this._set("icon", value);
		},

		/**
		 * Apply new text to DOM
		 * @param {string|string[]} value 
		 */
		_setTextAttr: function(value) {
			const {textNode} = this;

			html.clear(textNode);

			if (Array.isArray(value)) {
				value.forEach(s => html.create("span", {innerText: s}, textNode));
			} else if (value) {
				html.text(textNode, value);
			}

			this._set("text", value);
		},

		/**
		 * Apply icon positioning
		 * @param {boolean} value 
		 */
		_setIconLeftAttr: function(value) {
			domClass.toggle(this.domNode, "csi-text-with-icon-left", value);
			this._set("iconLeft", value);
		},

		/**
		 * Apply icon color
		 * @param {string} value 
		 */
		_setIconColorAttr: function(value) {
			domStyle.set(this.iconNode.domNode, {color: value});
			this._set("iconColor", value);
		},

		/**
		 * Apply iconOnly attribute
		 * @param {string} value 
		 */
		_setIconOnlyAttr: function(value) {
			domClass.toggle(this.domNode, "csi-text-with-icon-icon-only", value);
			this._set("iconOnly", value);
		},

		/**
		 * Remove cursor pointer from icon
		 * @param {boolean} value 
		 */
		_setRemoveIconPointerCursorAttr: function(value) {
			domStyle.set(this.iconNode.domNode, {cursor: value ? "default" : ""});
			this._set("removeIconPointerCursor", value);
		}

	});
});